import { RCTContainer, RCTContentContainer, RCTHeaderContainer } from './ResponsiveComparisonTable.styles';
import { RCTProductsHeader } from './RCTProductsHeader';
import { RCTTableContent } from './RCTTableContent/RCTTableContent';
import { useState } from 'react';
import UtilityCardsHeader from './UtilityCardsHeader/UtilityCardsHeader';
import { ResponsiveComparisonTableProps } from './ResponsiveComparisonTable.types';

const ResponsiveComparisonTable = ({ products, utilityCards, categories }: ResponsiveComparisonTableProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <RCTContainer>
      {utilityCards && <UtilityCardsHeader utilityCards={utilityCards} />}
      <RCTHeaderContainer>
        <RCTContentContainer backgroundColor="#fff">
          <RCTProductsHeader products={products} isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        </RCTContentContainer>
      </RCTHeaderContainer>
      <RCTContentContainer backgroundColor="#f5f5f5">
        <RCTTableContent products={products} isExpanded={isExpanded} categories={categories} />
      </RCTContentContainer>
    </RCTContainer>
  );
};

export default ResponsiveComparisonTable;
